import { Dayjs } from 'dayjs';
import type { BaseEntity } from './BaseEntity';
import type { InventoryItem } from './InventoryItem';
import type { Vendor } from './Vendor';

export interface PurchaseOrder extends BaseEntity {
  dateTimePurchased: Dayjs;
  vendorId: number;
  vendor?: Vendor;
  inventoryItems?: InventoryItem[];
  totalOrderCost?: number;
}

type ValidationResult = { issues: { message: string; path: (keyof PurchaseOrder)[] }[] };

export function validate(purchaseOrder: Partial<PurchaseOrder>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!purchaseOrder.dateTimePurchased) {
    issues = [...issues, { message: 'Date purchased is required', path: ['dateTimePurchased'] }];
  }

  if (!purchaseOrder.vendorId) {
    issues = [...issues, { message: 'Vendor is required', path: ['vendorId'] }];
  }

  if (!purchaseOrder.inventoryItems) {
    issues = [...issues, { message: 'Items are required', path: ['inventoryItems'] }];
  }

  return { issues };
}